// https://www.meticulous.ai/blog/safer-exhaustive-switch-statements-in-typescript

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const exhaustiveGuard = (_: never): never => {
  throw new Error(`Error - Unexpected default case ${_}!`);
};
